//Shared styles
const lineClamp2 = {
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	WebkitLineClamp: 2,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
};

export const styles = {
	// Event item styles
	event: {
		iconStyle: { marginRight: '.375rem', position: 'relative', top: '2px' },
		lineClampSx: lineClamp2,
	},

	// Event detail card styles
	eventDetailCard: {
		minWidthProps: { base: 'full', md: '350px' },
		iconStyle: { marginRight: '.375rem', position: 'relative', top: '1px' },
		lineClampSx: lineClamp2,
	},

	//Event modal styles
	eventDetailModal: {
		descriptionSx: {
			paddingBottom: '50px',
		},
		modalMinWidth: { md: '850px' },
		getDirection: {
			inputFocusStyle: { boxShadow: 'none' },
			inputSx: {
				'::placeholder': {
					color: 'gray.800',
					opacity: 1,
				},
				color: 'gray.800',
			},
		},
	},

	// Calendar toolbar icons
	toolbar: {
		iconStyle: { margin: '0px' },
	},

	// View-specific styles
	views: {
		month: {
			fontSize: { base: 'xs', sm: 'sm' },
		},
	},

	// Filters styles
	filters: {
		filterPillsWrap: { base: 'wrap', md: 'nowrap' },
		filterPillResetHover: { bg: 'red.600' },
		filterPopoverOutline: { outline: 'none' },
	},
};
